var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3126 2.99983C16.3125 2.27502 15.7249 1.6875 15.0001 1.6875H3C2.27513 1.6875 1.6875 2.27513 1.6875 3V4.18934C1.6875 4.53744 1.82578 4.87128 2.07192 5.11742L6.88259 9.92808C6.91775 9.96324 6.9375 10.0109 6.9375 10.0607L6.9375 14.4144C6.9375 15.0167 7.34739 15.5417 7.93167 15.6877L9.43167 16.0627C10.2601 16.2698 11.0625 15.6433 11.0625 14.7894L11.0625 10.0607C11.0625 10.0109 11.0823 9.96325 11.1174 9.92809L15.9283 5.11747C16.1745 4.87129 16.3128 4.53737 16.3128 4.1892L16.3126 2.99983ZM15.0001 2.8125C15.1036 2.8125 15.1876 2.89643 15.1876 2.99998L15.1878 4.18934C15.1878 4.23908 15.168 4.28679 15.1328 4.32195L10.3219 9.13257C10.0758 9.37871 9.9375 9.71256 9.9375 10.0607L9.9375 14.7894C9.9375 14.9114 9.82287 15.0009 9.70453 14.9713L8.20453 14.5963C8.12106 14.5755 8.0625 14.5005 8.0625 14.4144L8.0625 10.0607C8.0625 9.71256 7.92422 9.37872 7.67808 9.13258L2.86742 4.32192C2.83225 4.28676 2.8125 4.23907 2.8125 4.18934V3C2.8125 2.89645 2.89645 2.8125 3 2.8125H15.0001Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6e3e41ea18d8249367a770b102e000af.svg";
export { ForwardRef as ReactComponent };